import Pako from 'pako';

export default async function fetchGzipFromR2AsJsonViaCfFunctions(key) {
  // Get data stream
  const response = await fetch(
    // `${process.env.PUBLIC_URL}/devData/${key}`,
    `${process.env.PUBLIC_URL}/api/${key}`,
    { headers: { 'Authorization': `Bearer ${process.env.REACT_APP_BUCKET_AUTH}` } }
  );

  // Deflate and convert to text string
  const buffer = await response.arrayBuffer();
  const uint8 = Pako.inflate(buffer);
  const str = new TextDecoder().decode(uint8);

  // Return as JSON object
  return JSON.parse(str);
}